// sport admin
import adminLearnPage from './sport/adminLearnPage/actions'
import adminTicketPage from './sport/adminTicketPage/actions'
import adminReportPage from './sport/adminReportPage/actions'
import adminTariffPage from './sport/adminTariffPage/actions'
import adminSchedulePage from './sport/adminSchedulePage/actions'
import adminStatisticsPage from './sport/adminStatisticsPage/actions'
import adminAreaConfigPage from './sport/adminAreaConfigPage/actions'
import adminServiceConfigPage from './sport/adminServiceConfigPage/actions'
import adminScheduleInputPage from './sport/adminScheduleInputPage/actions'
import adminScheduleConfigPage from './sport/adminScheduleConfigPage/actions'

import adminGroupsConfigPage from './sport/adminGroupsConfigPage/actions'
import adminGroupsAddPage from './sport/adminGroupsAddPage/actions'
import adminLearnCalculatePage from './sport/adminLearnCalculatePage/actions'
import adminLearnTariffPage from './sport/adminLearnTariffPage/actions'

// edu admin
import adminCatalogPage from './edu/adminCatalogPage/actions'
import adminConfigSchoolsPage from './edu/adminConfigSchoolsPage/actions'
import adminConfigSchoolStagesPage from './edu/adminConfigSchoolStagesPage/actions'
import adminConfigDaysPage from './edu/adminConfigDaysPage/actions'
import adminConfigAccessPage from './edu/adminConfigAccessPage/actions'
import adminRegistryPage from './edu/adminRegistryPage/actions'
import adminReportFoodPage from './edu/adminReportFoodPage/actions'
import adminCancelFoodPage from './edu/adminCancelFoodPage/actions'

// sport customer
import customerOrderPage from './sport/customerOrderPage/actions'
import customerLearnPage from './sport/customerLearnPage/actions'
import customerCancelPage from './sport/customerCancelPage/actions'
import customerTicketPage from './sport/customerTicketPage/actions'
import customerSchedulePage from './sport/customerSchedulePage/actions'

// edu customer
import customerOrderFoodPage from './edu/customerOrderFoodPage/actions'
import customerCancelFoodPage from './edu/customerCancelFoodPage/actions'

// sport cashier
import cashierLearnPage from './sport/cashierLearnPage/actions'
import cashierLearnSalePage from './sport/cashierLearnSalePage/actions'
import cashierTicketPage from './sport/cashierTicketPage/actions'
import cashierCancelPage from './sport/cashierCancelPage/actions'
import cashierSchedulePage from './sport/cashierSchedulePage/actions'

// edu cashier
import cashierConfigFoodPage from './edu/cashierConfigFoodPage/actions'
import cashierControlFoodPage from './edu/cashierControlFoodPage/actions'
import cashierRegistryFoodPage from './edu/cashierRegistryFoodPage/actions'
import cashierCancelFoodPage from './edu/cashierCancelFoodPage/actions'
import cashierSalesFoodPage from './edu/cashierSalesFoodPage/actions'

// access
import layersNavigation from './layersNavigation/actions'
import accessLevel from './accessLevel/actions'


export default {
  // sport admin
  adminLearnPage,
  adminTicketPage,
  adminReportPage,
  adminTariffPage,
  adminSchedulePage,
  adminStatisticsPage,
  adminAreaConfigPage,
  adminServiceConfigPage,
  adminScheduleInputPage,
  adminScheduleConfigPage,

  adminGroupsConfigPage,
  adminGroupsAddPage,
  adminLearnCalculatePage,
  adminLearnTariffPage,

  // edu admin
  adminCatalogPage,
  adminConfigSchoolsPage,
  adminConfigSchoolStagesPage,
  adminConfigDaysPage,
  adminConfigAccessPage,
  adminRegistryPage,
  adminReportFoodPage,
  adminCancelFoodPage,
  
  // sport customer
  customerOrderPage,
  customerLearnPage,
  customerCancelPage,
  customerTicketPage,
  customerSchedulePage,

  // edu customer
  customerOrderFoodPage,
  customerCancelFoodPage,

  // sport cashier
  cashierLearnPage,
  cashierLearnSalePage,
  cashierCancelPage,
  cashierTicketPage,
  cashierSchedulePage,
  cashierCancelFoodPage,
  cashierSalesFoodPage,

  // edu cashier
  cashierConfigFoodPage,
  cashierControlFoodPage,
  cashierRegistryFoodPage,

  // access
  layersNavigation,
  accessLevel,
}
